module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_an@2x-4c1b7593aae708105d8e53772ac678bb.webp";